<div class="flex flex-row items-stretch justify-center m-auto gap-2">
    <app-button
        [disabled]="!measurementToolService.canUndo()"
        [htmlType]="'button'"
        [icon]="['fas', 'trash']"
        [iconSize]="'lg'"
        [tooltip]="'delete' | transloco"
        [type]="ButtonType.ALERT_SECONDARY"
        (click)="measurementToolService.clear()" />

    <app-button
        [disabled]="!measurementToolService.canUndo()"
        [htmlType]="'button'"
        [icon]="['fas', 'undo']"
        [iconSize]="'lg'"
        [tooltip]="'undoLastAction' | transloco"
        [type]="ButtonType.SECONDARY"
        (click)="measurementToolService.undoLastAction()" />

    <div
        class="text-caption flex flex-row items-center px-2 rounded-md bg-white min-w-[17.5rem] w-max whitespace-nowrap">
        <span [class.text-custom-dark-grey]="!measurementToolService.hasDistance()">
            {{ 'distance' | transloco }} : {{ measurementToolService.distance() }}
        </span>

        <span class="px-2 text-custom-dark-grey">|</span>

        <span [class.text-custom-dark-grey]="!measurementToolService.hasArea()">
            {{ 'surface' | transloco }} : {{ measurementToolService.area() }}
        </span>
    </div>
</div>
